module.exports = __webpack_public_path__ + "static/media/4q_website_logo_sup_scc.cae4e08d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4q_website_logo_sup_scc.jpg
// module id = 70
// module chunks = 0